import { Link } from 'react-router-dom';

import { labels } from '../labels.js';
import { Icon } from './Icon.js';
import styles from './CartBar.module.css';

interface CartBarProps {
  count: number;
  total: string;
}

/** Floating cart button above the bottom navigation. Hidden when the cart is empty. */
export function CartBar({ count, total }: CartBarProps) {
  if (count === 0) return null;
  return (
    <div className={styles.wrap}>
      <Link to="/panier" className={styles.bar}>
        <span className={styles.count}>{count}</span>
        <span className={styles.label}>{labels.menu.viewCart}</span>
        <span className={styles.total}>{total}</span>
        <Icon name="arrow-right" size={18} />
      </Link>
    </div>
  );
}
